import normalize from "jsonapi-normalizer";
import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { ParentProfileInfo } from "../../../api/typings/Profiles";
import { getUpdateParentData } from "../../serializers/usersProfilesParentsSerializer";
import { ProfilesParentsApi } from "../../../api/users/ProfilesParentsApi";

export class ProfileParentService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = async (data: ParentProfileInfo) => {
    const updateProfileData = await getUpdateParentData(data);
    const response = await ProfilesParentsApi.updateParentProfile(data.id!, updateProfileData);
    const { users_profiles_parents } = normalize(response).entities;
    this.ctx.usersProfilesParents = { ...this.ctx.usersProfilesParents, ...users_profiles_parents };
  };
}
